import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HybridToolsService } from '../../../services/hybrid-tools.service';
import { Component, Injector, OnDestroy } from '@angular/core';

@Component({
    template: ''
})
export abstract class BaseDialogComponent implements OnDestroy {
    private modal: NgbActiveModal;
    private location: Location;
    public hybridToolsService: HybridToolsService;
    private subscriber: Subscription;

    protected constructor(private injector: Injector) {
        this.modal = this.injector.get(NgbActiveModal);
        this.location = this.injector.get(Location);
        this.hybridToolsService = this.injector.get(HybridToolsService);

        window.history.pushState(null, null, window.location.href);

        this.subscriber = <Subscription>this.location.subscribe(event => {
            this.modal.dismiss();
        });

        this.hybridToolsService.conditionallyDisableBodyScrollOnMobile();
        this.hybridToolsService.addMobileSafariWorkaround();
    }

    ngOnDestroy() {
        this.hybridToolsService.conditionallyEnableBodyScrollOnMobile();
        this.hybridToolsService.removeMobileSafariWorkaround();
        this.subscriber.unsubscribe();
    }
}
